import gql from 'graphql-tag';

export default gql`
  mutation UnpairDevice($id: ID!) {
    unpairDevice(id: $id)
  }
`;
